// extracted by mini-css-extract-plugin
module.exports = {"Testimonies":"Testimonies_Testimonies__2yUoB","anim":"Testimonies_anim__30lTE","textAppear":"Testimonies_textAppear__3jdO4"};